module.exports = __webpack_public_path__ + "static/img/3.48c29b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sections/3.svg
// module id = fROy
// module chunks = 0